import { z } from "zod";

export const trackShopSchema = z.object({
  url: z.string().url().refine(
    (url) => url.includes("etsy.com/shop/") || url.includes("etsy.com/tr/shop/"),
    "Geçerli bir Etsy mağaza URL'si girin"
  ),
  name: z.string().optional(),
});

export type TrackShopInput = z.infer<typeof trackShopSchema>;
